"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Either = void 0;
const Effect_1 = require("./Effect");
const isRight = (e) => e[0];
class Either extends Effect_1.Effect {
    constructor(a) {
        super();
        this.fmap = (f) => Either.fmap(f, this);
        this.bind = (f) => Either.bind(f, this);
        this.identity = () => Either;
        this.isValide = () => Either.isRight(this);
        this.open = () => this.record[1];
        this._open = () => this.record;
        this.isLeft = () => !Either.isRight(this);
        this.isRight = () => Either.isRight(this);
        this.fromLeft = (d) => Either.fromLeft(d, this);
        this.fromRight = (d) => Either.fromRight(d, this);
        this.either = (f, g) => Either.either(f, g, this);
        this.case = (f, g) => Either.case(this, f, g);
        this.record = a;
    }
}
exports.Either = Either;
_a = Either;
Either.fmap = (f, a) => isRight(a.record) ? Either.right(f(a.record[1])) : new Either(a.record);
Either.bind = (f, a) => isRight(a.record) ? f(a.record[1]) : new Either(a.record);
Either.lift = (f) => (a) => Either.fmap(f, a);
Either.left = (a) => new Either([false, a]);
Either.right = (a) => new Either([true, a]);
Either.isLeft = (a) => !Either.isRight(a);
Either.isRight = (a) => isRight(a.record);
Either.fromLeft = (d, a) => !isRight(a.record) ? a.record[1] : d;
Either.fromRight = (d, a) => isRight(a.record) ? a.record[1] : d;
Either.either = (f, g, a) => isRight(a.record) ? g(a.record[1]) : f(a.record[1]);
Either.case = (a, f, g) => isRight(a.record) ? g(a.record[1]) : f(a.record[1]);
Either.liftFromThrowable = (f) => (...a) => {
    try {
        return Either.right(f(...a));
    }
    catch (e) {
        return Either.left(e);
    }
};
Either.liftFromThrowableAsync = (f) => (...a) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return Either.right(yield f(...a));
    }
    catch (e) {
        return Either.left(e);
    }
});
//# sourceMappingURL=Either.js.map